import React, { useState, useEffect } from 'react';
import axios from '../api/api';
import { useParams } from 'react-router-dom';
import Nav from './Nav'
import Footer from './Footer'

const ViewVideo = () => {
  const [view, setView] = useState('');
  const [content, setContent] = useState('')
  const { id } = useParams();

  useEffect(() => {
    const getVideoById = async () => {
      try {
        const response = await axios.get(`/api/v3/stream/${id}`, { responseType: 'blob' });
        const videoBlob = new Blob([response.data], { type: 'video/mp4' });
        const url = URL.createObjectURL(videoBlob);
        setView(url);
      } catch (error) {
        console.error('Error fetching video:', error.message);
        console.error(error);
      }
    };
    getVideoById();
  }, [id]);

  useEffect(() => {
    const getVideoDetails = async () => {
      try {
        const response = await axios.get(`/api/v3/contentdata/${id}`);
        setContent(response.data);
      } catch (error) {
        console.error('Error fetching video:', error.message);
        console.error(error);
      }
    };
    getVideoDetails();
  }, [id]);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 4000));
      setIsLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div>
      <Nav/>
      <div className='mx-auto p-4 lg:container'>
        <div className='flex items-center justify-center'>
          <div className='px-4'>
            <div className='p-2'>
              <p>Home / Movies / Full Movie</p>
            </div>
            <div>
              {isLoading
                ? (
                  <div>
                    <video width='1500' height='600' muted controls>
                      <source src={view} type='video/mp4' />
                    </video>
                  </div>
                  ) : (
                    <div className='w-full'>
                      {view.length > 0
                        ? (
                            <div className='flex flex-wrap'>
                              <div className='lg:w-3/4'>
                                <video width='1200' height='600' muted controls>
                                  <source src={view} type='video/mp4' />
                                  <source src='video.ogg' type='video/ogg' />
                                </video>
                              </div>
                              <div className='bg-slate-300 w-full lg:w-1/4 p-4'>
                                <p className='bg-blue-600 text-white p-4 font-bold'>Full Hd</p>
                              </div>
                            </div>
                          ) : (
                            <div className="relative">
                              <video width='1500' height='600' muted controls>
                                <source src={view} type='video/mp4' />
                              </video>
                              <h2 className='absolute inset-0 flex items-center justify-center text-red-600'>Full Video Loading....</h2>
                            </div>
                          )
                      }
                    </div>
                )
              }
            </div>
             <div className="flex flex-wrap p-4 mb-20 bg-white">
              <div>
                <img width={250} src={`https://naijaserver.cleverapps.io/api/v3/image/${content.coverPhoto}`} alt="" />
              </div>
              <div className='p-4 lg:w-1/2'>
                <h3>{content.movieName}</h3>
                <span>About: {content.movieSynopsis}</span>
                <div className='py-4 space-y-0.5'>
                  <p><b>Genre:</b> {content.movieType}</p>
                  <p><b>Actors:</b> {content.movieActors}</p>
                  <p><b>Director:</b> {content.movieProducer}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default ViewVideo;
